// phonenumber-link-class.js
jQuery(function ($) {

    $('a[href^="tel:"]').each(function() {
        $(this).addClass("link link--tel");
    });

});